import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasicResponse } from 'src/app/core/models/basic-response.model';
import { RequestsService } from 'src/app/core/services/requests.service';
import { getConnection, getEndpoint } from 'src/app/core/services/functions.service';

@Injectable({
    providedIn: 'root'
})
export class CargueTPService {

    ENDPOINT = getEndpoint('cargueProductosTP');

    constructor(
        private http: HttpClient,
        private requestService: RequestsService
    ) { }

    async obtenerPoliticas(company: string): Promise<any> {
        const url = `${this.ENDPOINT}/politicas/${company}`;
        return await this.http.get<any>(url).toPromise();
    }

    async cargarClientesPilotos(payload: any): Promise<BasicResponse> {
        const url = `${this.ENDPOINT}/clientes-pilotos`;
        return await this.requestService.postLikeJSON(url, payload);
    }
}